<template>
  <div class="setting_ui">
    <Breadcrumb></Breadcrumb>
    <div class="setting_content">
      <ul>
        <li v-for="item in helpList" :key="item.id">
          <h1>{{item.title}} 
            <span class="setting_btn" @click="item.show=!item.show">
              {{item.show?'收起':'查看'}}
              <i class="icon " :class="{'el-icon-arrow-down':!item.show,'el-icon-arrow-up':item.show}"></i>
              </span>
          </h1>
          
          <transition name="el-zoom-in-top">
            <div class="helpText" v-if="item.show" v-html="item.content">
            </div>
          </transition>
        </li>
        
      </ul>
    </div>
  </div>
</template>

<script>
import { helpCenterList } from '@/api/common_api'

import moment from 'dayjs'
import { Breadcrumb } from '@/components'

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
       helpList:[],
       id:this.$route.query.id||''
     };
  },
  created() {
      this.gethelpCenterList()
  },
  computed: {
    getText() {
      
    },
  },
  methods: {
   gethelpCenterList(){
      let _this = this
      helpCenterList().then(res => {
        if (res.s == 1) {
          res.d.forEach((element,i) => {
            element.show=false
            if(this.id==''&&i==0){
              element.show=true
            }
            if(this.id!=''&&element.id==this.id){
              element.show=true
            }
          });

          _this.helpList=res.d
        
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.setting_ui{
  width: 100%;
  min-height: 1052Px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(235, 235, 235, 0.5);
  padding:0 14Px;
  box-sizing: border-box;
  font-size:14Px;
  overflow: auto;
   &::-webkit-scrollbar {
      width: 0px;
      }
  .setting_content{
    min-height:100Px;
    padding-left:15Px;
    ul li{
       border-bottom:1px solid #EEEEEE;
    }
    h1{
      height: 22px;
      color:#191919;
      font-size: 16Px;
      margin:24Px 0 16Px;
      font-weight: 500;
      .setting_btn{
        float:right;
        margin-right:10Px;
        color:#1890FF;
        font-size: 14Px;
        cursor: pointer;
        .icon{
          font-size:12Px;
          margin-left:5Px;
        }
      }
    }
    .helpText{
      line-height:25Px;
      color:#666;
      word-wrap:break-word;
    }
    
  }
}
</style>
